import { createFileRoute } from '@tanstack/react-router';
import { AccessControlPage } from '../../features/access/AccessControlPage.jsx';

export const Route = createFileRoute('/_app/access-control')({ component: AccessControlPage });
